const DEFAULT_IPFS_GATEWAY = "https://serenity.ing/ipfs/";

export function toIpfsGatewayUrl(uri, gateway = DEFAULT_IPFS_GATEWAY) {
  if (!uri || typeof uri !== "string") return "";
  if (uri.startsWith("ipfs://")) {
    return `${gateway}${uri.replace("ipfs://", "")}`;
  }
  return uri;
}

export function getIpfsGatewayBase() {
  return process.env.REACT_APP_IPFS_GATEWAY || DEFAULT_IPFS_GATEWAY;
}
